import type { NextPage } from "next";
import Head from "next/head";
import { MetaTags } from "@helpers/meta-tags.helper";
import MainLayout from "@layouts/main-layout/main-layout";
import TechnologyComponent from "@components/expertise/technologies/technologies";
import { useRouter } from "next/router";
import { config } from "config";
import { generateProductJsonLd } from "@helpers/genereteProductsJsonLd";

const Technology: NextPage = () => {
  const router = useRouter();
  const url = `${config.HOST}${router.asPath}`;
  return (
    <>
      <Head>
        {MetaTags({
          title: "Our technologies",
          description: "Discover the tech behind our full-cycle solutions.",
          imageUrl: "/expertise-images/our-technologies-meta.png",
        })}
        <link rel="icon" href="/favicon.ico" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateProductJsonLd({
                serviceType: "Our technologies",
                description:
                  "Discover the tech behind our full-cycle solutions.",
                url,
              })
            ),
          }}
        />
      </Head>
      <MainLayout>
        <TechnologyComponent />
      </MainLayout>
    </>
  );
};

export default Technology;
